import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="7.05mm"
    height={16.851}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 29753 18816"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0{stroke:#2b2a29;stroke-width:1055.07}.fil0{fill:none}.fil2{fill:#2b2a29}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974616801296">
        <path
          d="M14877 528c7924 0 14349 2546 14349 5688s-6425 5689-14349 5689C6952 11905 528 9358 528 6216S6952 528 14877 528z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 1055.07,
          }}
        />
        <path
          d="M14866 3113c6481 0 11734 1395 11734 3114 0 1720-5253 3115-11734 3115-6480 0-11733-1395-11733-3115 0-1719 5253-3114 11733-3114z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 1055.07,
          }}
        />
        <path
          d="M14886 5255c3301 0 5978 407 5978 908 0 502-2677 909-5978 909-3302 0-5978-407-5978-909 0-501 2676-908 5978-908z"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 1055.07,
          }}

        />
        <path
          d="M15230 18288c167 0 304-137 304-304v-2552c0-168-137-304-304-304s-304 136-304 304v2552c0 167 137 304 304 304zM4925 15570c118 118 311 118 429 0l1805-1804c118-119 118-312 0-430s-311-118-429 0l-1805 1805c-119 118-119 311 0 429zM9841 17631c157 57 332-25 390-182l873-2399c57-157-25-332-182-389s-332 25-389 182l-874 2398c-57 157 25 332 182 390zM24828 15570c-118 118-311 118-429 0l-1805-1804c-118-119-118-312 0-430s312-118 430 0l1804 1805c119 118 119 311 0 429zM20030 17631c-157 57-332-25-390-182l-872-2399c-57-157 24-332 181-389h1c157-57 332 25 389 182l872 2398c58 157-24 332-181 390z"
          className="fill"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
